<template>
  <div class="o-page__content u-pt-small">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-12">
          <h1 class="u-h3">Approve Employee New Outlet</h1>
          <div class="custom_toolbar">
            <input
              type="text"
              placeholder="Search..."
              class="c-input"
              v-model="q"
              v-on:keyup="search"
            />
            <!-- <el-button style="margin-left: 20px;" type="success" round icon="el-icon-plus">Create New</el-button> -->
          </div>
        </div>
      </div>
      <div class="row u-mt-medium">
        <div class="col-12">
          <vue-good-table
            v-loading="loading"
            mode="remote"
            :columns="columns"
            :rows="rows"
            :totalRows="totalRecords"
            @on-page-change="onPageChange"
            @on-per-page-change="onPageChange"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true,
              disableSelectInfo: true,
            }"
            :pagination-options="{
              enabled: true,
            }"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'action'">
                <el-tooltip class="item" effect="dark" content="Reject" placement="top">
                  <el-button
                    size="mini"
                    icon="el-icon-close"
                    circle
                    type="danger"
                    @click="approve(props.row.originalIndex)"
                  ></el-button>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" content="Approve" placement="top">
                  <el-button
                    size="mini"
                    icon="el-icon-check"
                    circle
                    type="success"
                    @click="approve(props.row.originalIndex)"
                  ></el-button>
                </el-tooltip>

                <!-- <el-button size="mini" type="danger" icon="el-icon-delete" @click="showAlertDelete(props.row.id)" circle></el-button> -->
              </span>
              <span v-else-if="props.column.field == 'outlet_name'">
                {{ props.row.outlet_name }} ({{ props.row.outlet_code }})
              </span>
              <span v-else-if="props.column.field == 'new_outlet_name'">
                {{ props.row.new_outlet_name }} ({{ props.row.new_outlet_code }})
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import api from "@/api/employees";

export default {
  components: {
    "vue-good-table": VueGoodTable,
  },
  data() {
    return {
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "NPP",
          field: "npp",
        },
        {
          label: "Before",
          field: "outlet_name",
        },
        {
          label: "After",
          field: "new_outlet_name",
        },
        {
          label: "Action",
          field: "action",
          thClass: "u-text-center",
          tdClass: "u-text-center",
          width: "180px",
        },
      ],
      rows: [],
      totalRecords: 0,
      page: 1,
      perPage: 10,
      q: "",
      loading: false,
      user_role_id: localStorage.getItem("user_role_id"),
      user_relation_code: localStorage.getItem("relation_code")
        ? localStorage.getItem("relation_code")
        : "",
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    ...mapActions(["logout"]),
    fetch() {
      this.loading = true;
      var self = this;
      var region_code = this.user_relation_code;
      if (region_code == null) {
        region_code = "";
      }
      api
        .getApprove(this.page, this.q, region_code, this.perPage)
        .then(function (response) {
          self.rows = response.data.data;
          self.totalRecords = response.data.meta.totalRecords;
          self.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    onPageChange(params) {
      console.log(params);
      this.page = params.currentPage;
      this.perPage = params.currentPerPage;
      this.fetch();
    },
    search() {
      this.fetch();
    },
    approve(index) {
      var self = this;
      api
        .doApprove(this.rows[index].npp)
        .then(function (response) {
          self.$message({
            message: "Success approve employee new outlet",
            type: "success",
          });
          self.fetch();
          self.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    reject(index) {
      var self = this;
      api
        .doReject(this.rows[index].npp)
        .then(function (response) {
          self.$message({
            message: "Success reject employee new outlet",
            type: "success",
          });
          self.fetch();
          self.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom_toolbar {
  display: flex;
  div {
    margin-right: 10px;
  }
}
</style>
